import ApplicationSerializer from "./application";
import ENV from "glesys-controlpanel/config/environment";

export default class UserSerializer extends ApplicationSerializer {
  usesProxy = true;
  primaryKey = "username";

  attrs = {
    createdAt: "createdat",
    twoFactorMethod: { key: "twofactormethod", serialize: false },
    invites: { serialize: false },
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.links = {
      organizations: `${ENV.apiBaseUri}/user/listorganizations`,
      invites: `${ENV.apiBaseUri}/user/listinvites`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }
}
